import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Sectionbureau from '../../components/Sectionbureau/Sectionbureau';
import { motion } from 'framer-motion'
import { FiArrowRight, FiArrowUpRight } from 'react-icons/fi'
import './SectionArmoire.css'

const SectionArmoire = () => {
  const [infob, setInfob] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [tableThumb, setTableThumb] = useState(null)

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/armoire/lister6`)
      .then(res => {
        setInfob(res.data)
        setIsLoading(false)
      })
      .catch(err => {
        console.error("Erreur lors du chargement des données:", err)
        setIsLoading(false)
      })

    axios.get(`${process.env.REACT_APP_API_URL}/table/lister6`)
      .then(res => setTableThumb(res.data?.[0]?.image || null))
      .catch(() => setTableThumb(null))
  }, [])

  const armoireThumb = infob[0]?.image || null

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  const cards = infob.map((card) => (
    <motion.div
      key={card._id}
      className='col-lg-3 col-md-4 col-6 mb-4'
      variants={itemVariants}
    >
      <Sectionbureau
        nom={card.nom}
        titre={card.titre}
        prix={card.prix1}
        image={card.image}
        id={card._id}
      />
    </motion.div>
  ))

  return (
    <div className='container hd-selarmoire py-5'>
      <motion.div
        className="hd-selarmoire-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <span className="hd-selarmoire-eyebrow">Notre sélection</span>
        <h2 className="hd-selarmoire-title">
          Espaces <em>Rangement</em>
          <motion.span
            className="hd-selarmoire-underline"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.8, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          />
        </h2>
        <p className="hd-selarmoire-subtitle">
          Découvrez notre sélection exclusive de rangements design et fonctionnels
        </p>
      </motion.div>

      {isLoading ? (
        <div className="d-flex justify-content-center py-5">
          <div className="spinner-grow hd-selarmoire-spinner" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
        </div>
      ) : (
        <motion.div
          className='row'
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {cards}
        </motion.div>
      )}

      <motion.div
        className="hd-selarmoire-more"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <Link to="/armoire" className="hd-selarmoire-btn">
          <span>Voir toute la collection</span>
          <FiArrowRight />
        </Link>
      </motion.div>

      <motion.div
        className='row gy-4 mt-5'
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
      >
        <Link className='col-md-6 hd-selarmoire-banner' to="/table">
          {tableThumb && (
            <span className="hd-selarmoire-banner-thumb">
              <img src={tableThumb} alt="" />
            </span>
          )}
          <span className="hd-selarmoire-banner-eyebrow">Explorez</span>
          <h3 className="hd-selarmoire-banner-label">Table</h3>
          <div className="hd-selarmoire-banner-content">
            <span className="hd-selarmoire-banner-cta">Voir la collection</span>
            <span className="hd-selarmoire-banner-arrow">
              <FiArrowUpRight />
            </span>
          </div>
        </Link>

        <Link className='col-md-6 hd-selarmoire-banner' to="/armoire">
          {armoireThumb && (
            <span className="hd-selarmoire-banner-thumb">
              <img src={armoireThumb} alt="" />
            </span>
          )}
          <span className="hd-selarmoire-banner-eyebrow">Explorez</span>
          <h3 className="hd-selarmoire-banner-label">Rangement</h3>
          <div className="hd-selarmoire-banner-content">
            <span className="hd-selarmoire-banner-cta">Voir la collection</span>
            <span className="hd-selarmoire-banner-arrow">
              <FiArrowUpRight />
            </span>
          </div>
        </Link>
      </motion.div>

      <motion.div
        className="hd-selarmoire-divider"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      />
    </div>
 )
}
export default SectionArmoire
